import router from '@/router'
import { useOrderStore } from '@/stores/order'
import { useUserStore } from '@/stores/user'

// browserTrackSDK 由 index.html 引入并在 main.ts 中 init，运行时从 window 懒取，
// 避免模块加载早于 SDK 注入导致 undefined
const getTrackSDK = () => (window as any).browserTrackSDK

interface OrderMonitorParams {
    /** 埋点事件名，对应 SDK customTrack 的第一个参数 */
    eventName: string
    /** 事件类型：pageview / click / pageclick 等 */
    new_event_type?: string
    /** 页面名称，便于后台按页面维度聚合 */
    page_name?: string
    /** 点击内容描述 */
    click_content?: string
    /** 是否成功 */
    is_success?: boolean | string
    /** 失败原因 */
    fail_reason?: string
    /** 采集到的附加信息 */
    acquire_information?: string
    /** 登录方式 */
    login_type?: string
    /** 手机号（登录相关埋点使用） */
    phoneNumber?: string
    /** 用户 uid，未传时回退到 store 中的登录用户 */
    uid?: string | number
    [key: string]: any
}

/**
 * 订单流程通用埋点上报
 * 从小程序迁移：
 * - 订单信息由 wx.getStorageSync('ONLINE_ORDER_INFO') 改为 useOrderStore().orderInfo
 * - 用户信息由 wxUserInfo / userInfo 改为 useUserStore().userInfo
 * - 当前页面路径由小程序页面栈改为 Vue Router 的 currentRoute
 * - invitecode 由 OnlineOrderFlow 改为 orderStore.orderQuery
 */
const orderMonitor = (params: OrderMonitorParams) => {
    const sdk = getTrackSDK()
    if (!sdk?.customTrack) return

    const orderStore = useOrderStore()
    const userStore = useUserStore()
    const orderInfo = orderStore.orderInfo || {}
    const userInfo = userStore.userInfo || {}

    const defaultParams = {
        unionid: userInfo.unionid || '',
        path: router.currentRoute.value.path,
        uid: userInfo.uid || '',
        phone_no: params.phoneNumber || '',
        uid_no: params.uid ? String(params.uid) : '',
        order_no: orderInfo.orderNo || '',
        new_event_type: params.new_event_type || '',
        page_name: params.page_name || '',
        click_content: params.click_content || '',
        is_success: params.is_success ?? '',
        fail_reason: params.fail_reason || '',
        product_group_name: orderInfo.productGroupName || '',
        product_group_id: orderInfo.productGroupId || '',
        product_id: orderInfo.productId || '',
        product_name: orderInfo.productName || '',
        acquire_information: params.acquire_information || '',
        login_type: params.login_type || '',
        invite_code: orderStore.orderQuery?.invitecode || '',
        duration: params.duration || '',
        resource_content: params.resource_content || ''
    }

    sdk.customTrack(params.eventName, defaultParams)
}

export const setLoginId = (uid:any) => {
    const sdk = getTrackSDK()
    sdk.login(uid)
}

export const clearLoginId = () => {
    const sdk = getTrackSDK()
    sdk.clearLoginId()
}

export default orderMonitor
